/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect } from 'react';
import {
  Button,
  Flex,
  Icon,
  Link,
  Stack,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { InfoOIcon } from '@tonic-one/react-icons';
import { useTranslation } from 'react-i18next';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';

import isEqual from 'lodash/isEqual';
import { DlpPolicyItem } from 'src/pages/Policy/utils/types';
import { TitleLabel } from 'src/components/Common/FormComponent';
import DlpTemplateModal from 'src/pages/Policy/DataLossPrevention/Components/DlpTemplateModal';
import AdvancedOptionsModal from './Modal';
import {
  useComplianceRulesInit,
  useDlpTemplateAddEdit,
  useSelectedDlpTemplateColumns,
  useSelectedDlpTemplateRows,
} from '../../hooks/dlpFilter';
import { ComplianceRuleTransfer } from 'src/pages/Policy/DataLossPrevention/Components/ComplianceRulesTransfer';
import CSpinner from 'src/components/CSpinner';
import { DlpFileAdvancedOption } from './ActionNotification';
import {
  dlpTemplatesSelector,
  mipLabelsSelector,
} from '@Policy/store/filters/dlp';
import { usePermissionStore } from '../../../../../../models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
import { salesforceAdvancedSettingsSelector } from '@Policy/store/filters/webReputation';
import AdvancedSettingsModal from '@Policy/AdvancedThreatProtection/PolicyTemplate/Components/AdvancedSettingsModal';

export const AdvancedSettingsShowSalesforce = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = React.useState(false);
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const advancedSettingsConfig = contextSelector(
    salesforceAdvancedSettingsSelector,
    isEqual
  );
  const setDpState = contextSelector((s) => s.setDpState);
  // advanced optino
  const handleAdvancedSettings4FilesClose = useCallback(() => {
    setIsVisible(false);
  }, []);
  const handleAdvancedSettingsSave = useCallback(
    (config: {
      secondActionEnabled: number;
      secondActionType: number;
      replaceFileTagContent: string;
      replaceText: string;
      firstActionEnabled?: number;
      firstActionType?: number;
    }) => {
      // save config
      setDpState({
        dpFileTagEnabled: config.firstActionEnabled,
        dpFileAction: config.firstActionType,
        dpSecondActionEnabled: config.secondActionEnabled,
        dpSecondActionType: config.secondActionType,
        dpFileTagContent: config.replaceFileTagContent,
        dpReplacementText: config.replaceText,
      });
      // close the modal
      setIsVisible(false);
    },
    []
  );
  return (
    <>
      <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
        {t('policy.action.advancedSettings.title')}
      </Link>
      <AdvancedSettingsModal
        availableTokenShow={true}
        isVisible={isVisible}
        onClose={handleAdvancedSettings4FilesClose}
        config={advancedSettingsConfig}
        saveConfig={handleAdvancedSettingsSave}
        isExtraAction={true}
      />
    </>
  );
};

export const AdvancedOptions = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = React.useState(false);
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  const changeRecipientDisclaimer = policySelector(
    (s) => s.tmDpfilters.changeRecipientDisclaimer
  );
  const changeRecipientEmailAddressList = policySelector(
    (s) => s.tmDpfilters.changeRecipientEmailAddressList
  );
  const setDpState = contextSelector((s) => s.setDpState);
  const handleChangeRecipientDisclaimer = useCallback((message: string) => {
    setDpState({
      changeRecipientDisclaimer: message,
    });
  }, []);
  const handleChangeRecipientEmailAddressList = useCallback((list: string) => {
    setDpState({
      changeRecipientEmailAddressList: list,
    });
  }, []);
  //const contextStore = usePolicyContext();
  // get store selector
  // const contextSelector = storeSelector(contextStore);
  // const handleAdvancedOptionSave = useCallback(
  //   ({ replaceFileName, replaceText }) => {
  //     // save config
  //     // setVsState({
  //     //   vsReplacementFileName: replaceFileName,
  //     //   vsReplacementText: replaceText,
  //     // });
  //     // close the modal
  //     setIsVisible(false);
  //   },
  //   []
  // );
  // const advancedOptionConfig = contextSelector({} as any, isEqual);
  return (
    <>
      <Flex mb="24px" mt="16px">
        <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
          {t('policy.dlp.advanceOptions.show')}
        </Link>
      </Flex>
      <AdvancedOptionsModal
        visible={isVisible}
        onClose={() => setIsVisible(false)}
        onConfirm={() => setIsVisible(false)}
        changeRecipientDisclaimer={changeRecipientDisclaimer}
        changeRecipientEmailAddressList={changeRecipientEmailAddressList}
        setChangeRecipientDisclaimer={handleChangeRecipientDisclaimer}
        setChangeRecipientEmailAddressList={
          handleChangeRecipientEmailAddressList
        }
      />
    </>
  );
};

const ComplianceRuleNote = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  return (
    <Flex gap="8px" align="stretch" pt="16px">
      <Icon as={InfoOIcon} color={colorStyle.color.info} />
      <Text fontSize="semibold" wordWrap="break-word">
        {t('common.label.note')}:
      </Text>
      <Text> {t('policy.dlp.ComplianceRule.desc')}</Text>
    </Flex>
  );
};

export const ComplianceRules = (props: {
  complianceRuleNoteShow: boolean;
  advancedOptionsShow: boolean;
  fileAdvancedOptionsShow: boolean;
  advancedSettingsShowSalesforce: boolean;
  mipShow: boolean;
  // actionOptions?: ActionEnum[];
}) => {
  const { widthEditablePermission } = usePermissionStore();
  const dlpEditPermission = widthEditablePermission(
    PermissionNameEnum.dlpPolicy
  );
  const { t } = useTranslation();
  const {
    complianceRuleNoteShow,
    advancedOptionsShow,
    mipShow,
    fileAdvancedOptionsShow,
    advancedSettingsShowSalesforce,
  } = props;
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state from store
  const dlpTemplates = contextSelector(dlpTemplatesSelector, isEqual);
  const mipLabels = contextSelector(mipLabelsSelector, isEqual);
  // get action from store
  const addDlpTemplates = contextSelector((s) => s.addDlpTemplates);
  const addDlpTemplatesAndMipLabels = contextSelector(
    (s) => s.addDlpTemplatesAndMipLabels
  );
  const syncLabels = contextSelector((s) => s.syncLabels);
  // local state
  const [isLoading, setIsLoading] = React.useState(false);
  const { selectedDlpTemplateColumns } = useSelectedDlpTemplateColumns();
  const { dlpRows } = useSelectedDlpTemplateRows(
    mipShow,
    selectedDlpTemplateColumns
  );
  const { handleInit } = useComplianceRulesInit(mipShow, setIsLoading);
  // add
  const {
    isAddModalVisible,
    handleAddModalClose,
    handleAddModalOpen,
    handleAddModalSave,
    dlpTemplateDetail,
  } = useDlpTemplateAddEdit({ setIsLoading });
  const handleSyncLabels = React.useCallback(async () => {
    setIsLoading(true);
    await syncLabels();
    setIsLoading(false);
  }, []);
  useEffect(() => {
    handleInit();
  }, []);
  return (
    <>
      {isLoading && <CSpinner />}
      <>
        <Stack mt="32px">
          <TitleLabel title={t('policy.dlp.complianceRules')} />
          <Stack
            mt="16px"
            direction="row"
            shouldWrapChildren={true}
            spacing="12px"
          >
            {mipShow ? (
              <Button
                variant="secondary"
                onClick={handleSyncLabels}
                disabled={!dlpEditPermission}
              >
                {t('policy.dlp.syncLabel')}
              </Button>
            ) : null}
            <Button
              variant="secondary"
              onClick={() => handleAddModalOpen()}
              disabled={!dlpEditPermission}
            >
              {t('common.action.label.add')}
            </Button>
            {/* <Button variant="secondary">{t('common.action.label.import')}</Button> */}
          </Stack>
          <ComplianceRuleTransfer
            mipShow={mipShow}
            mipLabels={mipLabels}
            dlpTemplates={dlpTemplates}
            dlpRows={dlpRows}
            selectedDlpTemplateColumns={selectedDlpTemplateColumns}
            addDlpTemplates={addDlpTemplates}
            addDlpTemplatesAndMipLabels={addDlpTemplatesAndMipLabels}
            handleAddModalOpen={handleAddModalOpen}
          />
          {complianceRuleNoteShow && <ComplianceRuleNote />}
          {advancedOptionsShow && <AdvancedOptions />}
          {fileAdvancedOptionsShow && (
            <DlpFileAdvancedOption
              availableTokenShow={true}
              replaceFileNameShow={false}
              mipFeatureShow={mipShow}
              syncLabels={handleSyncLabels}
            />
          )}
          {advancedSettingsShowSalesforce && <AdvancedSettingsShowSalesforce />}
        </Stack>
        <DlpTemplateModal
          isVisible={isAddModalVisible}
          onClose={handleAddModalClose}
          onSave={handleAddModalSave}
          initialState={dlpTemplateDetail}
        />
      </>
    </>
  );
};
export default React.memo(ComplianceRules);
